import { render } from "./CommandPalette.vue?vue&type=template&id=46b61bcc&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"

import "./CommandPalette.vue?vue&type=style&index=0&id=46b61bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b61bcc"]])

export default __exports__